module.exports = __webpack_public_path__ + "img/pr-15.ed004868.png";